import { render, staticRenderFns } from "./ModalHotakauth.vue?vue&type=template&id=4b13751c"
import script from "./ModalHotakauth.vue?vue&type=script&lang=js"
export * from "./ModalHotakauth.vue?vue&type=script&lang=js"
import style0 from "./ModalHotakauth.vue?vue&type=style&index=0&id=4b13751c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports